import { OnboardingTour, type TourStep } from '@babomrs/ui';

/**
 * Client-portal first-run tour — #10803 AC5.
 *
 * Plain-language and shorter than the staff tour: different audience, different
 * language (frontend-ui-system.md). The mechanism is shared (@babomrs/ui).
 *
 * #10803 AC7: no client data and no worked example naming a real person or entity.
 */
const STEPS: TourStep[] = [
  {
    title: 'Welcome to your portal',
    body: 'This is where you and your accountant share documents, sign paperwork and answer questions. Here is a quick look around — you can skip it at any time.',
  },
  {
    title: 'Documents',
    body: 'Documents holds everything we have shared with you and everything you have sent us. You can open or download anything here whenever you need it.',
  },
  {
    title: 'Signing',
    body: 'When something needs your signature it appears under Documents to sign. Open it, read it, and sign on screen — on your phone as easily as on a computer.',
  },
  {
    title: 'Queries',
    body: 'If we need something from you, we raise a query. Answering it here keeps your reply attached to the right job so nothing gets lost in email.',
  },
  {
    title: 'Help whenever you need it',
    body: 'The Help button at the top of the page explains whatever screen you are on, and links to a searchable list of every topic. If you are still stuck, raise a query and we will help directly.',
  },
];

const STORAGE_KEY = 'babomrs.tour.client.v1';

export function ClientOnboardingTour({ open, onClose }: { open?: boolean; onClose?: () => void }) {
  return <OnboardingTour steps={STEPS} storageKey={STORAGE_KEY} open={open} onClose={onClose} skipLabel="Skip Tour" />;
}
